class detailSelect {
    constructor(container) {
      this.container = container;
      this.options = container.querySelectorAll('.we-select > .we-select__item');
      this.value = container.querySelector('input:checked').value;
      this.mouseDown = false;
      this._addEventListeners();
      this._setAria();
      this.updateValue();
      
      // Update variant availability after a short delay to ensure Shopify's variant system is ready
      setTimeout(() => {
        this.updateVariantAvailability();
      }, 100);
    }
  
    // Private function to set event listeners
    _addEventListeners() {
      this.container.addEventListener('toggle', () => {
        if (this.container.open) return;
        this.updateValue();
      })

      this.container.addEventListener('focusout', e => {
        if (this.mouseDown) return;
        this.container.removeAttribute('open');
      })

      this.options.forEach(opt => {
        opt.addEventListener('mousedown', () => {
          this.mouseDown = true;
        })
        opt.addEventListener('mouseup', () => {
          this.mouseDown = false;
          this.container.removeAttribute('open');
        })
      })

      this.container.addEventListener('keyup', e => {
        const keycode = e.which;
        const current = [...this.options].indexOf(this.container.querySelector('.active'));
        switch (keycode) {
          case 27: // ESC
            this.container.removeAttribute('open');
            break;
          case 35: // END
            e.preventDefault();
            if (!this.container.open) this.container.setAttribute('open', '');
            this.setChecked(this.options[this.options.length - 1].querySelector('input'))
            break;
          case 36: // HOME
            e.preventDefault();
            if (!this.container.open) this.container.setAttribute('open', '');
            this.setChecked(this.options[0].querySelector('input'))
            break;
          case 38: // UP
            e.preventDefault();
            if (!this.container.open) this.container.setAttribute('open', '');
            this.setChecked(this.options[current > 0 ? current - 1 : 0].querySelector('input'));
            break;
          case 40: // DOWN
            e.preventDefault();
            if (!this.container.open) this.container.setAttribute('open', '');
            this.setChecked(this.options[current < this.options.length - 1 ? current + 1 : this.options.length - 1].querySelector('input'));
            break;
        }
      })
      
      // Listen for variant changes from other parts of the system to keep our select in sync
      document.addEventListener('variant:change', (e) => {
        if (e.detail && e.detail.optionName === this.container.dataset.optionName) {
          this.syncWithVariant(e.detail.value);
        }
      });
      
      // Listen for Shopify's variant change events
      if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
        this.variantChangeUnsubscriber = window.subscribe(window.PUB_SUB_EVENTS.variantChange, (event) => {
          // Update variant availability when variants change
          setTimeout(() => {
            this.updateVariantAvailability();
          }, 50);
        });
      }
    }

    // Clean up event listeners when the component is destroyed
    destroy() {
      if (this.variantChangeUnsubscriber) {
        this.variantChangeUnsubscriber();
      }
    }

    // Sync the custom select with a specific variant value
    syncWithVariant(value) {
      const input = this.container.querySelector(`input[value="${value}"]`);
      if (input && input !== this.container.querySelector('input:checked')) {
        this.setChecked(input);
      }
    }

    // Update variant availability based on Shopify's variant data
    updateVariantAvailability() {
      // Find the variant-selects element to get variant data
      let variantSelects = this.container.closest('variant-selects');
      if (!variantSelects) {
        const section = this.container.closest('[data-section]');
        if (section) {
          variantSelects = section.querySelector('variant-selects');
        }
      }
      
      if (variantSelects && variantSelects.variantData) {
        const variantData = variantSelects.variantData;
        const optionName = this.container.dataset.optionName;
        
        // Update availability for each option
        this.options.forEach(option => {
          const input = option.querySelector('input');
          const value = input.value;
          
          // Check if this option value is available with current selections
          const isAvailable = variantData.some(variant => {
            // Find the option index for this option name
            const optionIndex = this.getOptionIndex(optionName);
            if (optionIndex === -1) return true;
            
            return variant[`option${optionIndex + 1}`] === value;
          });
          
          if (isAvailable) {
            input.classList.remove('disabled');
            input.disabled = false;
          } else {
            input.classList.add('disabled');
            input.disabled = true;
          }
        });
      }
    }
    
    // Get the option index (0-based) for a given option name
    getOptionIndex(optionName) {
      const variantSelects = this.container.closest('variant-selects') || 
                            this.container.closest('[data-section]')?.querySelector('variant-selects');
      
      if (variantSelects) {
        const optionElements = variantSelects.querySelectorAll('.product-form__controls');
        for (let i = 0; i < optionElements.length; i++) {
          const label = optionElements[i].querySelector('.product-form__group-name');
          if (label && label.textContent.includes(optionName)) {
            return i;
          }
        }
      }
      return -1;
    }
  
    _setAria() {
      this.container.setAttribute('aria-haspopup', 'listbox');
      this.container.querySelector('.we-select').setAttribute('role', 'listbox');
      const summary = this.container.querySelector('.we-select-container__summary');
      summary.setAttribute('aria-label', `unselected listbox`);
      summary.setAttribute('aria-live', `polite`);
      this.options.forEach(opt => {
        opt.setAttribute('role', 'option');
      });
    }
  
    updateValue(e) {
      const that = this.container.querySelector('input:checked');
      if (!that) return;
      this.setValue(that)
    }
  
    setChecked(that) {
      that.checked = true;
      this.setValue(that)
    }
  
    setValue(that) {
      if (this.value == that.value) return;

      const summary = this.container.querySelector('.we-select-container__summary');
      const pos = [...this.options].indexOf(that.parentNode) + 1;
      summary.innerHTML = that.parentNode.querySelector('label').innerHTML;
      summary.setAttribute('aria-label', `${that.value}, listbox ${pos} of ${this.options.length}`);
      this.value = that.value;

      this.options.forEach(opt => {
        opt.classList.remove('active');
        opt.setAttribute('aria-selected', 'false');
      })
      that.parentNode.classList.add('active');
      that.parentNode.setAttribute('aria-selected', 'true');

      // Dispatch the change event for the container
      this.container.dispatchEvent(new Event('change'));
      
      // Find the variant-selects element and trigger its change event to update Shopify variants
      // Try multiple strategies to find the variant-selects element
      let variantSelects = this.container.closest('variant-selects');
      
      if (!variantSelects) {
        // Look for variant-selects in the same section
        const section = this.container.closest('[data-section]');
        if (section) {
          variantSelects = section.querySelector('variant-selects');
        }
      }
      
      if (!variantSelects) {
        // Look for variant-selects globally
        variantSelects = document.querySelector('variant-selects');
      }
      
      if (variantSelects) {
        // Trigger the change event on the variant-selects element
        // This will call onVariantChange() which updates all the variant-dependent elements
        variantSelects.dispatchEvent(new Event('change'));
        // console.log('Custom select: Triggered variant update via variant-selects element');
      } else {
        // console.warn('Custom select: Could not find variant-selects element to trigger variant update');
      }
      
      // Also trigger the pubsub variant-change event if available
      if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
        window.publish(window.PUB_SUB_EVENTS.variantChange, {
          target: this.container,
          value: that.value,
          optionName: this.container.dataset.optionName
        });
        // console.log('Custom select: Published variant-change event via pubsub');
      }
      
      // Trigger a custom event that other parts of the system might be listening for
      this.container.dispatchEvent(new CustomEvent('variant:change', {
        detail: {
          target: this.container,
          value: that.value,
          optionName: this.container.dataset.optionName
        }
      }));
      
      // Close the details element after selection
      this.container.removeAttribute('open');
    }
  }

// Make the class globally available
window.detailSelect = detailSelect;

// Initialize all detail select components when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  // Store references to all detailSelect instances
  window.detailSelectInstances = [];
  
  document.querySelectorAll('.we-select-container').forEach(container => {
    const instance = new detailSelect(container);
    window.detailSelectInstances.push(instance);
  });
});

// Clean up function that can be called if needed
window.cleanupDetailSelects = function() {
  if (window.detailSelectInstances) {
    window.detailSelectInstances.forEach(instance => {
      if (instance && typeof instance.destroy === 'function') {
        instance.destroy();
      }
    });
    window.detailSelectInstances = [];
  }
};

